import { useOrgContext } from 'Data/context/Organizations';
import PropTypes from 'prop-types';
import BOSFilterSelect from './index';

const OrganizationSelect = ({
  onSelectOrganization,
  defaultSelectedId,
  excludedIds,
  includeFunc,
  ...props
}) => {
  const { getFilteredList } = useOrgContext();
  let filteredList = getFilteredList({ excludedIds, includeFunc });

  return (
    <BOSFilterSelect
      listData={filteredList}
      onItemSelect={onSelectOrganization}
      placeholder='Select a Core Facility...'
      defaultSelectedId={defaultSelectedId}
      searchFunction={(org) => {
        return `${org.name} ${org.short_name}`;
      }}
      fill
      {...props}
    />
  );
};

OrganizationSelect.propTypes = {
  onSelectOrganization: PropTypes.func,
  defaultSelectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  excludedIds: PropTypes.array,
  includeFunc: PropTypes.func,
  onBlur: PropTypes.func,
};

export default OrganizationSelect;
